<template>
  <ARow>
    <ACol v-for="(item) in msgs" :key="item.message? item.message.messageId : Math.random()">
      <ATooltip :title="JSON.stringify(item.message)" v-if="item.message" >
        <ATag v-if="!item.isSend">收到来自{{item.message.from}}：
          <span v-if="!item.isImage && !item.isFile">{{ item.message.content }}</span>
          <span v-if="item.isFile">文件<a :href="item.message.content" target="_blank" :download="item.message.fileName">{{item.message.fileName}}</a></span>
        </ATag>
        <ATag v-if="item.isSend">已发送给 {{item.message.to}}： <span v-if="!item.isImage">{{ item.message.content }}</span></ATag>
        <img v-if="item.isImage" style="max-width:120px;max-height:120px;" :src="item.message.content">
      </ATooltip>
    </ACol>
  </ARow>
</template>

<script>
export default {
  name: "ReceiveBox",
  props: {
    msgs: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped></style>
